export default __webpack_public_path__ + "static/media/service-2.06167915.jpg";